import React, { useCallback, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Add } from '@mui/icons-material';
import { IconButton } from '@mui/material';
import { FadingTooltip } from '@cosmotech/ui';
import { CreateDataStoreItemWizard } from './components/CreateDataStoreItemWizard';

export const CreateDataStoreItemButton = () => {
  const { t } = useTranslation();
  const [isCreationWizardOpen, setIsCreationWizardOpen] = useState(false);
  const handleCloseDialog = useCallback(() => {
    setIsCreationWizardOpen(false);
  }, [setIsCreationWizardOpen]);

  return (
    <>
      <FadingTooltip title={t('commoncomponents.datastore.create.tooltip', 'Create a datastore')}>
        <IconButton
          color="primary"
          onClick={() => setIsCreationWizardOpen(true)}
          data-cy="create-dataset-button"
          sx={{ height: '100%' }}
        >
          <Add fontSize="large" />
        </IconButton>
      </FadingTooltip>
      <CreateDataStoreItemWizard open={isCreationWizardOpen} closeDialog={handleCloseDialog} />
    </>
  );
};
